"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importDefault(require("react"));
var react_i18next_1 = require("react-i18next");
var TechnicalInfo = function () {
    var t = (0, react_i18next_1.useTranslation)().t;
    return (react_1["default"].createElement("div", { className: "TechnicalInfo" },
        react_1["default"].createElement("p", null,
            react_1["default"].createElement("u", null, t('gear')),
            react_1["default"].createElement("br", null),
            react_1["default"].createElement("br", null),
            "\u2022 Seinheiser MKH 416, Rode NTG-2, Rode VideoMic",
            react_1["default"].createElement("br", null),
            "\u2022 Deity Theos 2XTransmitter + receiver + omni directional lavalier mic",
            react_1["default"].createElement("br", null),
            "\u2022 Zoom F6 & H2N recorders",
            react_1["default"].createElement("br", null),
            "\u2022 Boom + shock mount + deadcat",
            react_1["default"].createElement("br", null),
            "\u2022 Sennheiser SM58",
            react_1["default"].createElement("br", null),
            "\u2022 Audio-Technica AT 2035 + mic screen + pop filter",
            react_1["default"].createElement("br", null),
            "\u2022 Hardware synths: Juno 106, Roland D50, Waldorf",
            react_1["default"].createElement("br", null),
            "blofeld, MS-20 mini, TT-303, DSI Mopho x4, Yamaha Reface CS/DX/CP, .."),
        react_1["default"].createElement("p", null,
            react_1["default"].createElement("u", null, t('software')),
            react_1["default"].createElement("br", null),
            react_1["default"].createElement("br", null),
            react_1["default"].createElement("img", { src: "images/live.png", height: 25 }),
            " Ableton live (expert)",
            react_1["default"].createElement("br", null),
            react_1["default"].createElement("img", { src: "images/pureD.png", height: 25 }),
            " Pure data (expert)",
            react_1["default"].createElement("br", null),
            react_1["default"].createElement("img", { src: "images/premiere.png", height: 25 }),
            " Adobe Premiere (expert)",
            react_1["default"].createElement("br", null))));
};
exports["default"] = TechnicalInfo;
